import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Action } from 'src/app/core/models/action.model';
import {
  CaseConfiguration,
  ClaimRequirement,
  ClaimRequirementStatus,
  ClaimsService,
  ClaimWithCase,
} from 'src/app/core/services/claims.service';
import { CommunicationService } from 'src/app/core/services/communication.service';

@Component({
  selector: 'app-os-actions-case',
  templateUrl: './os-actions-case.component.html',
  styleUrls: ['./os-actions-case.component.scss'],
})
export class OsActionsCaseComponent implements OnInit {
  @Input() public claim?: ClaimWithCase;
  @Input() public showImage: boolean = true;
  @Input() public showDetails: boolean = false;

  @Output() actionsChanged = new EventEmitter<Action[]>();
  pendingNumber = 0;

  constructor(private dialog: MatDialog, private router: Router) {}

  async ngOnInit() {}

  async refresh() {}

  changeActions(actions: Action[]) {
    this.pendingNumber = actions.filter((action) => {
      switch (action.action_type) {
        case 'QUESTIONNAIRE':
          return action.ac_status !== 'DONE' && action.ac_status !== 'SUBMITTED';

        case 'KYC':
          // CPK-4442: postponed segue 'DONE' pro gating, mas conta como pendente
          return action.ac_status !== 'DONE' || !!action.postponed;

        case 'SIGNATURE':
          return action.ac_status !== 'SIGNED';

        default:
          return !action.ac_status;
      }
    }).length;
    this.actionsChanged.emit(actions);
  }

  navigateToClaim() {
    this.dialog.closeAll();
    this.router.navigate(['/client/claim', this.claim!.id]);
  }
}
